/**
 * Returns the meter label
 * @param {string} identifier - meter identifier
 * @param {string} title - meter title
 * @returns {string| null} - meter label
 */
const getMeterLabel = (identifier, title) => {
  if (!identifier && !title) {
    return null;
  }

  if (!title) {
    return identifier;
  }

  let meterDetails = title || '';
  meterDetails = identifier ? `${title} (${identifier})` : meterDetails;
  return meterDetails?.trim();
};

export default getMeterLabel;
